import React from "react";
import { MdDone } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { GoDotFill } from "react-icons/go";

const MAP = {
  delivered: {
    label: "Delivered",
    className: "bg-[#ECFDF3] text-[#027A48]",
    Icon: MdDone,
  },
  cancelled: {
    label: "Cancelled",
    className: "bg-[#FEF3F2] text-[#DC2626]",
    Icon: IoClose,
  },
  failed_delivery: {
    label: "Failed Delivery",
    className: "bg-[#FEF3F2] text-[#DC2626]",
    Icon: IoClose,
  },
  new_order: {
    label: "New Order",
    className: "bg-[#EFF6FF] text-[#2563EB]",
    Icon: GoDotFill,
  },
  out_delivery: {
    label: "Out for Delivery",
    className: "bg-[#F3E8FF] text-[#7C3AED]",
    Icon: GoDotFill,
  },
  processing: {
    label: "Processing",
    className: "bg-[#FFF6ED] text-[#EA580C]",
    Icon: GoDotFill,
  },
  ready_pickup: {
    label: "Ready for Pick-up",
    className: "bg-[#FFFBEB] text-[#D97706]",
    Icon: GoDotFill,
  },
};

export function OrderStatusBadge({ status }) {
  const cfg = MAP[status] ?? MAP.processing;
  const Icon = cfg.Icon;
  return (
    <span
      className={`inline-flex max-w-full items-center gap-0.5 rounded-full px-2 py-0.5 text-[10px] font-bold sm:gap-1 sm:px-3 sm:py-1 sm:text-[11px] ${cfg.className}`}
    >
      <Icon className="shrink-0 text-[11px] sm:text-[12px]" aria-hidden />
      {cfg.label}
    </span>
  );
}
